module.exports = __webpack_public_path__ + "img/contact_active.e04a0dc4.svg";